import dateFormat from 'dateformat'
import timestamp from "unix-timestamp";
import {DateTime} from "luxon";

const isString = x => typeof x === 'string'

const isValidDate = string => /\d{4}-\d{2}-\d{2}/.test(string)

const length = x => x.length
const zeroLength = x => length(x) === 0
const duplicate = (y) => y.filter((v, i) => y.indexOf(v) === i)

const isEmptyString = x => isString(x) && zeroLength(x)

const reFormatJSON = x => JSON.parse(JSON.stringify(x))
const cloneObject = x => Object.assign({}, x)
const cloneObjectArray = x => x.map(cloneObject)

const isNull = x => x === null
const isTruthyOrNull = x => x || isNull(x)

const assignPositions = xs =>
    xs.map((x, position) => Object.assign({}, x, {position}))

const getCookie = (name) => {
  let value = '; ' + document.cookie
  let parts = value.split('; ' + name + '=')
  if (parts.length === 2) return parts.pop().split(';').shift()
}

const deleteCookie = (name) => {
  document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;'
}

const formatData = (date) => {
  return dateFormat(date, 'yyyy-mm-dd H:MM:ss')
}

const catchHandler = (e) => {
  deleteCookie('accessToken')
  location.reload()
  console.log('err', e)
}

const updateDate = (payload) => {
  let state = {};
  let todayDate = new Date()
  let todayDateUnix = timestamp.now()
  let oneDayUnix = 86400
  let startToday = timestamp.fromDate(todayDate.getFullYear() + '-' + (todayDate.getMonth() + 1)  + '-' + (todayDate.getDate()) + ' ' + '00:00:01');
  let endToday = timestamp.fromDate(todayDate.getFullYear() + '-' + (todayDate.getMonth() + 1)  + '-' +  (todayDate.getDate()) + ' ' + '23:59:59');
  switch (payload.typeDate) {
    case 'Today':
      state.fromDate = startToday
      state.toDate = endToday
      break;
    case 'Yesterday':
      state.fromDate = startToday  - oneDayUnix
      state.toDate = endToday - oneDayUnix

      break;
    case 'Week to date':
      state.fromDate = startToday - (oneDayUnix * 6)
      state.toDate = todayDateUnix
      break;
    case 'Month to date':
      state.fromDate = startToday - (oneDayUnix * 30)
      state.toDate = todayDateUnix
      break;
    case 'Year to day':
      state.fromDate = startToday - (oneDayUnix * 365)
      state.toDate = todayDateUnix
      break;
    case 'fromDateCustom':
      state.fromDate = timestamp.fromDate(payload.date)
      break;
    case 'toDateCustom':
      state.toDate = timestamp.fromDate(payload.date)
      break;
    case 'Custom':
      state.fromDate = timestamp.fromDate(payload.fromDate)
      state.toDate = timestamp.fromDate(payload.toDate)
      break;
    case 'Last week':
      let firstDayOfTheWeek = todayDate.getDate() - todayDate.getDay()
      let lastDayOfTheWeek = firstDayOfTheWeek + 6
      let firstDayOfLastWeek = new Date(todayDate.setDate(firstDayOfTheWeek - 7))
      let lastDayOfLastWeek = new Date(todayDate.setDate(lastDayOfTheWeek - 7))
      state.fromDate = timestamp.fromDate(firstDayOfLastWeek)
      state.toDate = timestamp.fromDate(lastDayOfLastWeek)
      break;
    case 'Last month':
      let year = todayDate.getFullYear()
      let month = String(todayDate.getMonth()).length === 1 ? '0' + todayDate.getMonth() : todayDate.getMonth()
      let fromDay = '01'
      let toDay = '31'
      let fromLastMonthDate =  year + '-' + month  + '-' + fromDay
      let toLastMonthDate =  year + '-' + month + '-' + toDay

      if(todayDate.getMonth() === 0){
        month = '12'
        year = todayDate.getFullYear() - 1
      }

      if(month === '04' || '06' || '09' || '11'){
        toDay = '30'
      }else if (month === '02') {
        toDay = '28'
      }

      state.fromDate = timestamp.fromDate(fromLastMonthDate)
      state.toDate = timestamp.fromDate(toLastMonthDate)
      break;

  }

  return state;
}

const createPeriod = (result, period) => {
  const dates = [];
  const conversions = [];

  for (let i = period; i >= 1; i--) {
    const date = DateTime.now().startOf('day').minus({days: i}).toISODate();
    dates.push(date);
    const dateData = (result && result.statuses && result.statuses.count)
        ? result.statuses.data.find(d => d.day === date)
        : null;
    conversions.push(dateData ? dateData.conversions : 0)
  }

  return { dates, conversions }
};

export {
  isValidDate,
  isEmptyString,
  duplicate,
  reFormatJSON,
  cloneObject,
  formatData,
  catchHandler,
  cloneObjectArray,
  getCookie,
  deleteCookie,
  isTruthyOrNull,
  assignPositions,
  updateDate,
  createPeriod
}

